// extracted by mini-css-extract-plugin
module.exports = {"navbar":"styles_navbar__2Sblc","toggle":"styles_toggle__3RTVz","padding":"styles_padding__2td1U"};